import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";

const CreateRefund = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [isFixed, setFixed] = useState(actionStep?.action?.data.isFixed || false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const action = { type: isFixed ? ActionType.REFUND_SCANNED_ORDER : ActionType.REFUND_SELECTED_ORDER, data: { isFixed } };
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, isFixed]);

    return (
        <div className="function-add-cart-note-wrapper">
            <OliverText text="How would you like to process the refund?" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper" onClick={() => setFixed(false)}>
                    <div className="function-checkbox-label-wrapper">
                        <div className="refund-checkbox-wrapper">
                            <OliverText
                                text="Open Pop-up for selected order"
                                size="xs"
                                weight="medium-heavy"
                                translatePrefix="popup.actionBuilder."
                            />
                            <SimpleCheckbox callback={() => {}} checked={!isFixed} label="" value="" custom={false} />
                        </div>
                        <OliverText
                            text="This opens a refund pop-up for the selected order’s details, allowing you to select products to refund and return payments to the original method."
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                            style={{ maxWidth: "90%" }}
                        />
                    </div>
                </div>
                <div className="function-checkbox-wrapper" onClick={() => setFixed(true)}>
                    <div className="function-checkbox-label-wrapper">
                        <div className="refund-checkbox-wrapper">
                            <OliverText
                                text="Open Pop-up by scanning the receipt"
                                size="xs"
                                weight="medium-heavy"
                                translatePrefix="popup.actionBuilder."
                            />
                            <SimpleCheckbox callback={() => {}} checked={isFixed} label="" value="" custom={false} />
                        </div>

                        <OliverText
                            text="This will activate the scanner to scan the receipt barcode and open a refund pop-up with order details from the receipt, allowing you to select products to refund and return payments to the original method."
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                            style={{ maxWidth: "90%" }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateRefund;
